import type { TrackingReplay, ThemeClasses } from "../types";
import { TrackingReplayGridCard } from "./TrackingReplayGridCard";
import { TrackingReplayListRow } from "./TrackingReplayListRow";
import { DENSE_LIST } from "../../../../shared";

interface TrackingReplaysListProps {
  trackingReplays: TrackingReplay[];
  loading: boolean;
  selectedView: "grid" | "list";
  themeClasses: ThemeClasses;
  isDarkMode: boolean;
  deletingId: string | null;
  onView: (replay: TrackingReplay) => void;
  onDelete: (replay: TrackingReplay) => void;
}

export function TrackingReplaysList({
  trackingReplays,
  loading,
  selectedView,
  themeClasses,
  isDarkMode,
  deletingId,
  onView,
  onDelete,
}: TrackingReplaysListProps) {
  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  if (trackingReplays.length === 0) {
    return (
      <div
        className={`text-center h-full text-lg flex flex-col items-center justify-center ${themeClasses.textSecondary}`}
      >
        <i className="ri-route-line text-6xl mb-4 opacity-30"></i>
        <p>No hay grabaciones</p>
      </div>
    );
  }

  if (selectedView === "grid") {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4 sm:gap-6">
        {trackingReplays.map((replay) => (
          <TrackingReplayGridCard
            key={replay.id}
            replay={replay}
            themeClasses={themeClasses}
            isDarkMode={isDarkMode}
            onView={onView}
            onDelete={onDelete}
            isDeleting={deletingId === replay.id}
          />
        ))}
      </div>
    );
  }

  return (
    <div className={DENSE_LIST}>
      {trackingReplays.map((replay) => (
        <TrackingReplayListRow
          key={replay.id}
          replay={replay}
          themeClasses={themeClasses}
          onView={onView}
          onDelete={onDelete}
          isDeleting={deletingId === replay.id}
        />
      ))}
    </div>
  );
}
